const download = (data, fileName = "mapset", format = "pdf") => {
  const a = document.createElement("a");
  a.href = data instanceof Blob ? window.URL.createObjectURL(data) : data;
  a.download = `${fileName}.${format}`;
  a.click();
};

export default download;
